<template>
  <span class="main-container">
    

    <div class="header-area">

      <div class="all-content">
        <NavBarDark @challenge_clicked="signUp"></NavBarDark>
        <b-row class="text-left row-one">   
            <b-col col lg="1" md="3" sm="2" cols="1">
            </b-col>
            <b-col col lg="6" md="7" sm="8" cols="10">
                <div class="all-content">
                    <h1 class="text-left heading">Learn cutting-edge skills <span class="typed_container"><span class="typed_static">in </span><span class="typed_element"></span></span></h1>
                    <div class="text-left second-heading">Take your career to the next level!</div>
                    <b-button v-on:click="viewCourses" class="signup-btn">VIEW COURSES</b-button><br><br>
                </div>
                
            </b-col>
            <b-col col lg="4" md="7" sm="8" cols="10">
                <img class="gif-content" alt="product challenges" src="@/assets/laptop_skin_much_smaller_skills.svg" height="180px" width="380px">
            
            </b-col>
            <b-col col lg="1" md="1" sm="2" cols="1">
            </b-col>
            
        
        </b-row>
      </div>

      <vue-particles 
                color="#ffffff" 
                :particleSize="3"
                :particleOpacity="0.3"
                :clickEffect="false" 
                :hoverEffect="false">
      </vue-particles>
      
    </div>

    
    
    <b-container fluid class="text-center">
        <div class="platform-logos">
            <div class="platform-text">We have <b>200+ curated courses</b> from top educational platforms<br><br></div>
            <img src='@/assets/brand-logos/udemy.svg' class="platform-logo" />
            <img src='@/assets/brand-logos/coursera.svg' class="platform-logo" />
            <img src='@/assets/brand-logos/edx.png' class='platform-logo' />
            <img src='@/assets/brand-logos/udacity.png' class='platform-logo' />
            
        </div>
       
    </b-container>
  
    <b-container fluid class="text-center" id="explore">
    <h3 class="row-two-heading">Explore Our Platform</h3>
        <b-row class="row-two">
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
                <b-col col lg="3" md="6" sm="8" cols="10">
                    <img width="300px" height="300px" src="../assets/courses_ud.svg" 
                    alt="product jobs" class="img-fluid">
                </b-col>
                <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                    <div class="point-header-explore">
                      Learn and get ahead
                    </div>
                    <div class="point-content">
                      Take courses in <b>Web Development</b> (ReactJS, VueJS, NodeJS), <b>Mobile Development</b> (React Native, Android, iOS), <b>UX Design</b>, <b>Data Science</b>, and <b>Product Management</b> from beginner to the advanced level. 
                      
                    </div><br>
                    <b-button v-on:click="viewCourses" variant="outline" class="section-btns">START LEARNING</b-button>
                </b-col>
                <b-col col lg="2" md="3" sm="2" cols="1">
                </b-col>
        </b-row>


        <b-row class="row-two">
            <b-col col lg="2" md="3" sm="2" cols="1">
            </b-col>
            
            <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                <div class="point-header-explore">
                    Get custom learning paths (coming soon)
                </div>
                <div class="point-content">
                    We help you create a custom learning path based on your <b>future career goals, interests, and time horizon</b>. Every learner has different needs and capabilities and we 
                    use our expertise to help you maximize your success. 
                </div><br>
                <b-button v-if="!custom_path_interested" v-on:click="customInterest" variant="outline" class="section-btns">SHOW INTEREST</b-button>
                <b-button v-else variant="outline" class="section-btns"><b>CHEERS 🤙</b></b-button>
            </b-col>
            <b-col col lg="3" md="6" sm="8" cols="10">
                <img width="200px" height="200px" src="../assets/learning_path.svg" 
                alt="practice challenges" class="img-fluid">
            </b-col>
            <b-col col lg="2" md="3" sm="2" cols="1">
            </b-col>
        </b-row>


        <b-row class="row-two">
            <b-col col lg="2" md="3" sm="2" cols="1">
            </b-col>

            <b-col col lg="3" md="6" sm="8" cols="10">
                <img width="200px" height="200px" src="../assets/assessments.svg" 
                alt="practice challenges" class="img-fluid">
            </b-col>

            <b-col col lg="5" md="6" sm="8" cols="10" class="text-left point-one">
                <div class="point-header-explore">
                    Assess your skills (coming soon)
                </div>
                <div class="point-content">
                    We have thorough but quick <b>domain assessments</b> (Frontend / Mobile / Design) and <b>skill assessments</b> to help you 
                    know where you stand and what topics to improve. 
                </div><br>
                <b-button v-if="!assessment_interested" v-on:click="assessmentInterest" variant="outline" class="section-btns">SHOW INTEREST</b-button>
                <b-button v-else variant="outline" class="section-btns"><b>CHEERS 🤙</b></b-button>
            </b-col>
            
            <b-col col lg="2" md="3" sm="2" cols="1">
            </b-col>
        </b-row>

    </b-container>
    <div class="footer-component">
        <FooterDark></FooterDark>
    </div>
  </span>
</template>

<script>
// @ is an alias to /src
import NavBarDark from '@/components/NavBarDark.vue'
import FooterDark from '@/components/FooterDark.vue'
import firebase from '../services/firebase'
import router from '../router'
import Typed from 'typed.js'
import amplitude from 'amplitude-js/amplitude'

export default {
  name: 'Home',
  components: {
    NavBarDark,
    FooterDark
  },

  data: function() {
      return {
          custom_path_interested: false,
          assessment_interested: false
      }
  },

  mounted: function() {
      var typed = new Typed('.typed_element', {
          strings: ["Web Development", "Mobile Development", "UX Design", "Data Science", "Product Management"],
          smartBackspace: true,
          typeSpeed: 100,
          loop: true,
          loopCount: Infinity,
          showCursor: false
      });
  },
  methods: {

      viewCourses: function() {
          amplitude.getInstance().init('e145c56a131ad5d30cfe488387c01eac');
          amplitude.getInstance().logEvent("clicked on courses", { title: "courses clicked",
          artist: "The Beatles", genre: "Rock"});
          router.push('/home');
      },

      customInterest: function() {
          this.custom_path_interested = true;
      },

      assessmentInterest: function() {
          this.assessment_interested = true;
      },

      signUp: function() {
          console.log("inside signUp vue function");
          var provider = new firebase.auth.GoogleAuthProvider();
          var user = firebase.auth().currentUser;
          if (user === undefined || user === null) {
              firebase.auth().signInWithPopup(provider).then(function(result) {
                var user = result.user;
                var token = result.credential.accessToken;
                localStorage.token = token;
                var full_name = result.user.displayName;
                var first_name = full_name.split(" ");
                if (result.additionalUserInfo.isNewUser === true) {

                    mixpanel.identify(result.user.uid);
	  				mixpanel.track("first time user", {"email" : result.user.email});
                    
                    //google conversion event pixel
                    gtag('event', 'conversion', {'send_to': 'AW-732136931/nKCXCMzVtaUBEOOLjt0C'});

                    firebase.database().ref("users/" + result.user.uid + "/").set({
                        email: result.user.email,
                        photoURL: result.user.photoURL,
                        name: result.user.displayName,
                        firstName: first_name[0]
                    });

                    mixpanel.register({
                        "name": result.user.displayName,
        				"email": result.user.email,
        				"first_name": first_name[0],
        				"id": result.user.uid,
        				"last_login": new Date()
                    });

                    mixpanel.people.set({
	  					"$name": result.user.displayName,
	  					"$email": result.user.email,
	  					"$first_name": first_name[0],
	  					"$id": result.user.uid,
	  					"$last_login": new Date()
	  				});

                }
                
                
                if (user) {
                    router.push('/dashboard');
                }
              }).catch(function(error) {
                console.log("signin error with errorCode" + error.code + " and message " + error.message); 
              })
          } else {
              router.push('/dashboard');
          }
          
      },
      getInTouch: function() {
        router.push('/get-in-touch');
      }
  }
}
</script>

<style>

    #particles-js {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    canvas {
        display: inline-block;
    }

    .header-area {
        position: relative;
    }

    .main-container {
        font-family: Avenir;
    }

    .typed_element{
        color: white;
        font-size:1.52rem;
        font-weight: 500;
        color: #42f498;
    }


    .typed_static {
        color: white;
        font-size:1.52rem;
        font-weight: 500;
        color: #42f498;
    }
    
    @media(max-width: 599px) {
        .platform-logos {
            margin-top: 20%;
            margin-bottom: 20%;
        }

        .typed_container {
            display: block;
            margin-top: 4%;
            margin-bottom: 8%;
        }

        .all-content {
            margin: auto;
        }
    }
    
    .point-img {
        width: 100%;
        height: 42%;
        margin-bottom: 2%;
        margin-top: 5%;
    }

    .typed-cursor {
        color:lightgreen;
        margin-left: 5px;
        font-size:32px;
    }

    .company-logos {
        padding-bottom: 6%;
        padding-top: 4%;
    }

    .logo-brand {
        width: 120px;
        height: 50px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .logo-brand-big {
        width: 160px;
        height: 66px;
        margin-left: 20px;
        margin-right: 10px;
    }

    .platform-logo {
        margin: 0 3%;
        padding-bottom: 2%;
    }

    .platform-text {
        margin-top: 2%;
        padding-bottom: 2%; 
        font-size: 1.2rem;
    }
 
    @media (min-width: 992px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px; 
            margin-top:0px;
        }
    }
    
    @media (max-width: 380px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px !important; 
            width:350px !important;
            margin: auto !important;
            margin-top:40px;
        }
    }

    @media (max-width: 576px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: auto !important;
            margin-top:40px;
        }
    }

    @media (min-width: 767px) and (max-width: 991px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: 45%;
            margin-top:40px;
        }
    }


    @media (min-width: 576px) and (max-width: 767px) {
        .frame {
            background-image:url('../assets/macbook_reduced_small.png'); 
            background-repeat: no-repeat; 
            height:200px; 
            width:350px;
            margin: 20%;
            margin-top:40px;
        }
    }

    .signup-btn:hover {
        background-color:#f25792;
        color: #fff;
        border-color: #f25792;
    }

    @media (max-width: 992px) {
        .all-content {
            margin-bottom: 30%;
        }
    }

    @media (min-width:992px) {
       .signup-btn {
            margin-top:0%;
            padding-top:1.9%;
            padding-bottom:1.9%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:28%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.72rem;
            cursor: pointer;
            border-radius:60px;
            font-weight:800;
            z-index: 9999;
            position: absolute;
        }    
    }

    @media (max-width:991px) and (min-width:701px){
       .signup-btn {
            margin-top:0%;
            padding-top:2.7% !important;
            padding-bottom:2.7% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:28%;
            margin-top:5%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            position: absolute;
        }    
    }

    @media (max-width:700px) and (min-width:576px){
       .signup-btn {
            margin-top:5%;
            padding-top:3.4% !important;
            padding-bottom:3.4% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:37%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            position: absolute;
        }    
    }

    .gif-content {
            margin-left:0%; 
            margin-top:6%;
        }

    @media (max-width:576px) {
        .col {
            margin: auto;
        }

        .all-content {
            margin-bottom: 10%;
        }

        .gif-content {
            margin-left:0%; 
            margin-top:16%;
        }

        .signup-btn {
            padding-top:3.6%;
            padding-bottom:3.6%;
            padding-left:3.5%;
            padding-right:3.5%;
            justify-content: center;
            align-self: center;
            width:40%;
            margin-top:2%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.78rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            position: absolute;
        }    
    }

    @media (max-width:380px) {
       .signup-btn {
            margin-top:0%;
            padding-top:4%;
            padding-bottom:4%;
            padding-left:5%;
            padding-right:5%;
            justify-content: center;
            align-self: center;
            width:44%;
            margin-top:5%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            position: absolute;
        }    
    }    
    
    .header-area {
        color:#fff;
        /*background:linear-gradient(80deg, #5751d1, #798bf2); */
        background:linear-gradient(100deg, #5d37f3, #7668ea);
    }

    @media(max-width:576px) {
       .header-area {
            color:#fff;
            /*background:linear-gradient(80deg, #5751d1, #798bf2); */
            /*background:linear-gradient(100deg, #5751d1, #6d7edb);*/
            padding-bottom:10px;
        } 

        .heading {
            font-size: 1.4rem !important;
            margin-top:4% !important; 
            margin-bottom: 4% !important;
        }

        .second-heading {
            font-size: 1.3rem !important;
            margin-top:8% !important;
            margin-bottom:8% !important;
            font-weight: 500;
        }

        .typed-cursor {
            color:lightgreen;
            margin-left: 5px;
            font-size:1.6rem;
            margin-top: 4%;
        }
    }

    .heading {
        font-size: 1.4rem !important;
        margin-top:3%;
    }

    .second-heading {
        font-size: 1.3rem !important;
        margin-top:4% !important;
        margin-bottom:8% !important;
        font-weight: 400;
    }

    @media (max-width: 410px) {
        .heading {
            font-size: 1.4rem !important;
            margin-top:3%;
        }

        .second-heading {
            font-size: 1.3rem !important;
            margin-top:15% !important;
            margin-bottom:8% !important;
            font-weight: 500;
        }
    }

    .row {
        margin-left: 0px;
        margin-right: 0px;
    }

    .row-one {
        padding-top:7%;
        padding-bottom:7% !important;
    }

    .row-two {
        padding-top:3%;
        padding-bottom:5%;
        background-color:#fff;
        color:#555;
        margin:5% 0;
        font-family: Avenir;
    }

    .row-process {
        padding-top:3%;
        padding-bottom:5%;
        color:#555;
        margin-bottom:1%;
        padding-left: 1%;
        padding-right: 1%;
    }

    #process {
        background-color: #fafafa;
    }

    #explore {
        padding-top:6%;
    }

    .container-fluid {
        padding-top:3%;
        padding-bottom:3%;
        background-color:#fff;
        color:#555;
        width:100%;
    }

    .row-two-heading {
        text-align: center !important;
        margin-top:20px;
        margin-bottom:40px;
        font-weight: 500;
        font-family: Avenir;
    }

    /*.btn-secondary {
        background-color:#f25792 !important;
        border-color: #f25792 !important;
        font-size:1.1rem !important;
        font-weight:500 !important;
        color: #fff !important;
        padding-left:3% !important;
        padding-right:3% !important;
        padding-top:1.5% !important;
        padding-bottom:1.5% !important;
    }*/

    .point-header {
        color:#000; 
        font-size:1.2rem; 
        margin-top:4%;
        margin-bottom: 6%;
        font-weight:500;
        text-align: center;
    }

    .point-header-explore {
        color:#333; 
        text-align:left; 
        font-size:1.2rem; 
        margin-top:4%;
        margin-bottom: 2%;
        font-weight:500;
    }

    .point-content { 
        font-size:1rem; 
        margin-top:4%;
        color:#555;
        text-align: left;
    }

    .process-point {
        padding-left: 1%;
        padding-right: 1%;
        
    }

    

    .process-card {
        padding: 4% 14%;
        width:100%;
        height:90%;
        box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
        background-color: #fff;
        margin-top:0%;   
        margin-bottom: 2%;
        border-radius: 10px;   
    }


    .process-content {
        font-size:0.9rem; 
        margin-top:10px;
        margin-bottom: 2%;
        color:#555;
    }

    .btn.section-btns.btn-outline{
        border-color:#f25792;
        color: #f25792;
        background-color: #fff;
        border:#f25792 solid 2px;
        border-radius: 7px;
    }

    .section-btns {
        border-color:#f25792;
        color: #f25792;
        background-color: #fff;
        border:#f25792 solid 2px;
        padding-left: 3.5%;
        padding-right: 3.5%;
        padding-top:2.4%;
        padding-bottom:2.4%;
        border-radius: 7px;
        font-size:0.8rem;
        margin-bottom:20px;
    }

    .point-one {
        margin-left:60px;
    }

</style>

